import { storage, KEYS } from './storage';

export const THEMES = { DARK: 'dark', LIGHT: 'light' };

const THEME_EVENT = 'themechange';

export const getTheme = () =>
  storage.get(KEYS.THEME) === THEMES.DARK ? THEMES.DARK : THEMES.LIGHT;

export const applyTheme = (theme) => {
  const isDark = theme === THEMES.DARK;
  document.documentElement.classList.toggle('dark', isDark);
  const root = document.getElementById('root');
  if (root) root.classList.toggle('dark', isDark);
};

export const setTheme = (theme) => {
  const next = theme === THEMES.DARK ? THEMES.DARK : THEMES.LIGHT;
  storage.set(KEYS.THEME, next);
  applyTheme(next);
  window.dispatchEvent(new CustomEvent(THEME_EVENT, { detail: next }));
};

export const subscribeTheme = (handler) => {
  const onChange = (e) => handler(e.detail);
  window.addEventListener(THEME_EVENT, onChange);
  return () => window.removeEventListener(THEME_EVENT, onChange);
};
